const regularNumberFormatter = new Intl.NumberFormat("nl-NL");

function numberFormatter({ number }) {
    return regularNumberFormatter.format(number);
}

export default numberFormatter;
